import React from "react";

import styles from "./PreviousPage.module.scss";
import { Link, useNavigate } from "react-router";

interface PreviousPageProps {
  currentPage: string;
	title?: string;
}

const PreviousPage: React.FC<PreviousPageProps> = ({ currentPage, title }) => {
  const navigate = useNavigate();

  return (
   <>
	  <div className={styles.nav}>
      <div className={styles.back} onClick={() => navigate(-1)}>
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_71_2328)">
            <g clipPath="url(#clip1_71_2328)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.178359 9.35392C0.121822 9.30749 0.0769657 9.25232 0.0463598 9.19159C0.0157539 9.13086 -1.71971e-07 9.06575 -1.74846e-07 9C-1.7772e-07 8.93425 0.0157539 8.86914 0.0463598 8.80841C0.0769657 8.74768 0.121822 8.69252 0.178359 8.64608L4.42809 5.14686C4.513 5.07677 4.62127 5.02902 4.73918 5.00966C4.85709 4.99029 4.97933 5.00019 5.09039 5.0381C5.20146 5.07601 5.29636 5.14022 5.36305 5.22259C5.42975 5.30496 5.46524 5.40179 5.46502 5.50078L5.46502 8.00022L15.7858 8.00022C16.1078 8.00022 16.4167 8.10556 16.6444 8.29305C16.8721 8.48055 17 8.73484 17 9C17 9.26516 16.8721 9.51945 16.6444 9.70695C16.4167 9.89444 16.1078 9.99978 15.7858 9.99978L5.46502 9.99978L5.46502 12.4992C5.46524 12.5982 5.42975 12.695 5.36305 12.7774C5.29636 12.8598 5.20146 12.924 5.09039 12.9619C4.97933 12.9998 4.85709 13.0097 4.73918 12.9903C4.62127 12.971 4.513 12.9232 4.42809 12.8531L0.178359 9.35392Z"
                fill="#1C1D20"
              />
            </g>
          </g>
        </svg>
        <p>Назад</p>
      </div>
      <div className={styles.pages}>
        <Link to="/">Главная</Link>
        <div>/</div>
        <span>{currentPage}</span>
      </div>
    </div>
		<h2 className={styles.title}>{title}</h2>
	 </>
  );
};

export default PreviousPage;
